import React from "react";
import type { GameState } from "../../shared/types";

import * as gsf from "core/src/core/game-state-functions.js";

// Positioning container for anything drawn over the arena (countdown, paused, etc.).
// Picks a round/square container class from the map shape.
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  // Optional: when used inside GamePreview it's injected via cloneElement.
  gameState?: GameState;
}

export default function Overlay({ gameState, className, children, ...rest }: Props) {
  const containerClass = gsf.isRoundMap(gameState)
    ? "canvas-overlay-container-round"
    : "canvas-overlay-container";
  return (
    <div {...rest} className={(className ? className + " " : "") + containerClass}>
      {children}
    </div>
  );
}
